import type { DeliveryType } from 'shared/src/enums';
import MarketHome from './pages/MarketHome';
import type { ScreenItem } from 'shared/src/types';
import { WEB_ROUTE_PATHS } from 'shared/src/webRoutePaths';

export type MarketStackParamList = {
  MarketHome: {
    instanceId?: string;
    marketId: number;
    // deeplink
    extras?: {
      show_coupons: boolean;
      category_sno: number | null;
      order: string | null;
      delivery_type: DeliveryType;
    };
    // query parameter
    delivery_type?: DeliveryType;
    show_coupons?: string;
  };
};

export const MarketScreens: ScreenItem[] = [
  {
    name: 'MarketHome',
    component: MarketHome,
    path: WEB_ROUTE_PATHS.MarketHome,
    options: {
      title: '마켓 홈 - 에이블리 스토어',
    },
    convertParams: props => {
      const target = Array.isArray(props.extras)
        ? props.extras[0]
        : props.extras;

      const extras =
        typeof target === 'string'
          ? (() => {
              try {
                return JSON.parse(target);
              } catch {
                return {};
              }
            })()
          : target;

      return {
        instanceId: props.instanceId,
        //native는 params, RN -> RN은 sno
        marketId: extras.sno ?? props.params ?? 0,
        extras: typeof extras === 'string' ? JSON.parse(extras) : extras,
      };
    },
  },
];
